import React, { useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./style.module.scss";

export default function Drawer({
  handleClose,
  children,
  open,
  right,
  fullScreen,
}) {
  useEffect(() => {
    const { body, documentElement } = document;
    const scrollPosition = window.pageYOffset;
    if (open) {
      body.style.overflow = "hidden";
      documentElement.style.overflow = "hidden";
      body.style.position = "fixed";
      body.style.top = `-${scrollPosition}px`;
      body.style.width = "100%";
    } else {
      body.style.removeProperty("overflow");
      documentElement.style.removeProperty("overflow");
      body.style.removeProperty("position");
      body.style.removeProperty("top");
      body.style.removeProperty("width");
      window.scrollTo(0, scrollPosition);
    }
  }, [open]);

  return (
    <div
      className={cx({
        [styles.drawer]: true,
        [styles.open]: open,
        [styles.right]: right,
        [styles.fullScreen]: fullScreen,
      })}
    >
      {children}
      <div
        className={cx({ [styles.close]: true, [styles.right]: right })}
        onClick={handleClose}
      />
    </div>
  );
}

Drawer.propTypes = {
  children: PropTypes.children,
  open: PropTypes.bool.isRequired,
  right: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
};
